import types from '../types/container'

export default class profile {

  static setTab(tab) {
    return {
      type: types.SET_TAB,
      payload: {
        tab,
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/sections/activity/actions/container.js